export const translations = {
  'en-US': {
    translation: {
      addUser: 'Add User',
      editUser: 'Edit User',
      firstName: 'First Name',
      lastName: 'Last Name',
      name: 'Name',
      role: 'Role',
      status: 'Status',
      email: 'Email',
      phone: 'Phone',
      type: 'Type',
      details: 'Details',
      nodes: 'Nodes',
      roles: 'Roles',
      cancel: 'Cancel',
      submit: 'Submit',
      delete: 'Delete',
      create: 'Create',
      deleteNodeError: "Error deleting node",
      deleteConfirmation: "Are you sure you want to delete",
      warning: "Warning",
      Alert: "Alert",
      deleteSure: "Yes, I'm sure",
      nodesWillBeCreatedAt: 'Nodes will be created at',
      searchFor: 'Search for',
      rolesError: 'Error fetching roles',
      userListError: 'Error fetching user list',
      organisationListError: 'Error fetching organization list',
      loadingRoles: 'Loading roles...',
      selectRole: 'Select role',
      validEmail: 'Please enter a valid email address',
      requiredEmail: 'Email is required',
      resend: 'Resend',
      restrictedDomain:"Restricted email domain",
      addUserSuccess: 'User added successfully',
      editUserSuccess: 'User edited successfully',
      deleteUserSuccess: 'User deleted successfully',
      deleteModalAlertMessage: 'You are about to delete the user {{userName}}. All permissions for the user will be revoked.',
      deleteProceedMessage: 'Do you want to proceed with the deletion?',
      userAlreadyExist: 'User already exists with this email id.',
      addUserError: 'Could not add user. Please try again.',
      editUserError: 'Could not edit user. Please try again.',
      deleteUserError: 'Could not delete user. Please try again.',
      nodesError: 'Error fetching assigned nodes',
      childNodesError: 'Error loading hierarchy level',
      hierarchyError: 'Error fetching hierarchy',
      requestFailed: 'Request failed',
      emailSentSuccess: 'Activation email sent successfully!',
      activationEmailError: 'Failed to send activation email.',
      activationEmailError1:
        'Failed to send activation email. Please try again later.',
      allOrganisations: 'All Organizations',
      address: 'Address',
      hierarchyMetaError: 'Error fetching hierarchy details',
      nodeMetaError: 'Error loading node details',
      contactName: 'Contact Name',
      downloadTemplate: 'Download template',
      newOrg: 'New Organization',
      save: 'save',
      upload: 'upload',
      // uploadFailed: 'Upload failed',
      uploading: 'Uploading',
      dropExcel: 'Drop Excel sheet, or',
      browse: 'browse',
      importSettings: 'Import settings',
      addNodesSites: 'Add new nodes/sites',
      updateNodesSites: 'Update information on existing nodes/sites',
      disableNodesSites: 'Disable nodes/sites that no longer exist',
      disabled: 'Disabled',
      new: 'New',
      updated: 'Updated',
      siteInstallation: 'Sites',
      addOrgSuccess: 'Organization created successfully!',
      excelUploadError: 'Failed to save excel. Please try again.',
      saveError: 'Failed to save. Please try again later.',
      saveBadRequestError: 'Failed to save. This is likely a problem with the data you were trying to save.',
      telephone: 'Telephone',
      externalIds: 'External ids',
      contactEmail: 'Contact email',
      longitude: 'Longitude',
      latitude: 'Latitude',
      primaryContactName: 'Primary contact name',
      primaryContactEmail: 'Primary contact email',
      templateError: 'Error downloading template. Please try again later.',
      templateError1: 'Unable to get template. Please try again later.',
      home: 'Home',
      organisations: 'Organizations',
      users: 'Users',
      lightTheme: 'Light theme',
      darkTheme: 'Dark theme',
      login: 'Login',
      logout: 'Logout',
      activateUserAcc: 'Activate User Account',
      phoneNumber: 'Phone Number',
      optional: 'optional',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      endUser: 'End User License Agreement',
      iAccept: 'I accept the End User License Agreement.',
      iHereby: 'I hereby confirm that I have read and accepted the',
      eula: 'EULA',
      iRead: 'I have read the Honeywell Privacy Policy',
      iUnderstood: 'Yes, I have read and understand the',
      privacyPolicy: 'Privacy Policy',
      activate: 'activate',
      activationSuccess: 'Activation Success',
      newAccAccess:
        'In order to access your new account, sign in using your new username. This new username is shown below:',
      emailSent: 'New username has been sent to your email id.',
      signin: 'SIGN IN',
      activationError: 'Activation failed',
      pleaseTryAgain: 'Please try again',
      activationExpired: 'Activation token expired',
      activationExpiredText:
        'This may be because the email link has timed out, has already been used or was incorrect. If the problem persists, please request a new activation email.',
      contactSupport: 'Error. Please contact support',
      pwdMatch: 'Passwords must match',
      required: 'Required',
      eligiblePwd:
        'Password must contain at least 1 upper case letter, 1 lower case letter, 1 digit, 1 special character and at least 11 characters',
      invalidPhoneNumber: 'Phone number invalid',
      invalidName:
        'Name must not exceed 255 characters without leading or trailing spaces',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'timezone',
      timeZone: 'Time zone',
      commissioningStatus: 'Commissioning status',
      countryCode: 'Country code',
      childCount: 'Child count',
      sheetVersion: 'Sheet version',
      unknownError: 'Unknown Error. Please try again later.',
      preview: 'Preview',
      file: 'File',
      inCompatibleExcel: 'File must be in .xlsx format.',
      selectOrg: 'Select organization',
      noRecordFound: 'No records found',
      total: 'Total',
      items: 'Items',
      forbidden: 'Forbidden',
      noPermissionText: 'You do not have permission to access this page',
      accessPermission: 'Please log in to an account with access permissions',
      technicianExternalAccessPermission: 'Please log in to the mobile application',
      redirectToLogin: 'Redirecting to login page',
      errorUserSettings: 'Error fetching user settings',
      invalidSystemGuid: 'Invalid System Guid',
      languageNotSupported: 'Language not supported',
      subscriptions: 'Subscriptions',
      gatewayManagement: 'Gateway Management',
      subscriptionNumber: 'Subscription Number',
      orderNumber: 'Order Number',
      bundle: 'Bundle',
      activatedOn: 'activation date',
      order: 'order',
      editSubscription: 'Edit Subscription',
      noNodeSelected: 'No node selected',
      noUserSelected: 'No user selected',
      loadingBundles: 'Loading bundles...',
      bundlesError: 'Error fetching bundles',
      selectBundle: 'Select bundle',
      addSubscriptionSuccess: 'Subscription added successfully',
      addSubscriptionError: 'Could not add subscription. Please try again.',
      subscriptionInputValidationError: 'can be an alphanumeric value with a hyphen and must not exceed 13 characters',
      errorUserGlobalPrivileges: 'Error fetching user global privlieges',
      subscriptionAlreadyExist: 'Subscription already exists.',
      invalidSubscription: 'Invalid Subscription',
      Version: 'Version',
      systemType: 'System Type',
      systemId: 'System ID',
      reviewGatewayDetails: 'Review gateway details',
      site: 'Site',
      Organisation: 'Organization',
      gatewayRegistration: 'Gateway Registration',
      selectAnOrg: 'Select an Org',
      selectASite: 'Select a Site',
      register: 'Register',
      selectSiteToRegsiter: 'Select site to register the gateway',
      gatewayRegistrationFailureMsg: 'Failed to register the gateway with the Honeywell Sentience IOT Platform',
      gatewayRegistrationSuccessMsg: 'Gateway has been successfully registered with the Honeywell Sentience IOT Platform',
      siteEmptyMsg: 'All the sites for {{- orgName}} organization are already registered',
      forgeOnboarding: 'Org Mapping',
      SiteFetchingFailure: 'Failed to fetch sites from Forge',
      selectAllSitesText: 'Select all forge sites to onboard on Remote Building Manager',
      onBoardingFailure: 'Failed to initiate site onboarding',
      customerID: 'Customer ID',
      enterCustomerID: "Enter Customer ID",
      loadingSites: "Loading Sites...",
      fetchSites: "FETCH SITES",
      subscriptionActivateSuccess: 'Subscription for "{{siteName}}" is successfully activated',
      subscriptionActivateError: 'Cannot activate due to technical issue, please contact your admin',
      activateNow: 'Activate Now',
      multiSiteSuccess: 'Sites are added successfully.',
      onboardSelected: 'Onboard selected',
      sitePartialSuccess: 'Some sites failed to onboard due to technical issue. Please try again or contact your administrator.',
      confirm: 'Confirm',
      onboardingFailed: 'Onboarding failed',
      failed: 'failed',
      onboardedSuccessfully: 'Site onboarded',
      notOnboarded: 'Not onboarded',
      onboarding: 'Onboarding...',
      reOnboard: 'Re-Onboard',
      selectAll: 'Select All',
      siteSuccess: 'Site added successfully.',
      dataloseWarning: 'Please don\'t refresh the page while sites are onboarding.',
      addServiceSuccess: 'Services added successfully',
      addServicesText: 'Add Services',
      validityText: 'Validity Period',
      invalidInputError: 'Invalid Input',
      subsactivateError: 'Subscription already activated',
      subsnotfoundError: 'Subscription details not found',
      invalidorderError: 'Invalid order number',
      bundnotfoundError: 'Bundle details not found',
      subscribedServices: 'SUBSCRIBED SERVICES',
      subsactivateSuccess: 'Subscription created and activated successfully',
      subsactivateFailure: 'Subscription Created, But Activation Failed. Please try again !!',
      subsactivateDiffSite: 'Subscription Already Activated for a Different Site',
      gatewayAssociation: 'Gateway Association',
      systemGuid: 'System Guid',
      success: 'Success',
      contactSystemAdministrator: 'Please contact your system administrator',
      siteName: 'Site Name',
      location: 'Location',
      action: 'Action',
      addNewSite: 'Add New Site',
      add: 'Add',
      sitesAssociated: '{{siteCount}} Sites Associated',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Search Sites',
      noResultFound: 'No results found',
      noDataFound: 'No data found',
      loadMore: 'Load more',
      unlinkMessage: 'To unbind {{siteName}} from the {{sku}}, Please reach out to Honeywell Customer Care center (+01 480-353-3020) or email support@honeywell.com',
      associatedOrderNumber: 'Associated Order Number',
      associatedSubscriptionNumber: 'Associated Subscription Number',
      helperTextSKU: 'To modify Subscription number please reach out to',
      helperOrderTextSKU: 'To modify Order number please reach out to',
      customerCare: 'Customer care',
      skuDetails: 'SKU Details',
      manageSites: 'Manage Sites',
      skuName: 'SKU Name',
      skuDescription: 'SKU Description',
      licenseUtilization: 'License Utilization',
      validTill: 'Valid Till',
      editSKU: 'Edit SKU',
      duplicateSiteError: 'Site is already added',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Error fetching site list',
      siteSuccessMsg: 'Sites added successfully',
      siteFailedMsg: 'Sites failed to add',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'New Subscription Added',
      licensesOf: 'Licenses of',
      all: 'All',
      orderPlacedBy: 'Order Placed By',
      pendingRenewal: 'Pending Renewal',
      daysRemaining: 'Days Remaining',
      renewSubscriptionMessage: 'To Renew {{skuName}}, Please reach out to Honeywell Customer Care center (+01 480-353-3020) or email support@honeywell.com',
      columnSelection: 'Column Selection',
      selectUpTo: 'You can select up to',
      itemsToDisplay: 'items to display in the table.',
      subscriptionManagement: 'Subscription Management',
      activated: 'Activated',
      warningHeader: 'Are you sure you want to cancel?',
      warningMessage: 'There are unsaved changes that might get lost',
      renewSubscription: 'Renew Subscription',
      pendingActivation: 'Pending Activation',
      notAuthorizedError: 'You are not authorized to assign SKU to this Organization',
      gatewayRegistrationInProgress: '{{gateway}} In Progress',
      gatewayAssociationFailed: 'Please check gateway connectivity and retry. If fails again, please contact your System Administrator.',
      gatewayRegistrationFailed: 'Please retry. If fails again, please contact your System Administrator.',
      doAssociationMessage: 'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: 'Error in processing the association.',
      association: 'Association',
      dataloseWarningForRegistration: 'Gateway Registration is in progress, It may take few mins. Please don\'t refresh to avoid data loss.',
      dataloseWarningForAssociation: 'Gateway Association is in progress, It may take few mins. Please don\'t refresh to avoid data loss.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Unit',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Template added successfully',
      addTemplateError: 'Could not add template. Please try again.',
      updateTemplateSuccess: 'Template updated successfully',
      updateTemplateError: 'Could not update template. Please try again.',
      outOfRangeError: 'Value must be between {{min}} and {{max}}',
      requiredField: 'Please fill all the field(s)',
      templateName: 'Template Name',
      modelName: 'Model Name',
      vendorName: 'Vendor Name',
      uniqueValueError: 'Value must be unique',
      templateMangement: 'Template Management',
      equipmentType: 'Equipment type',
      selectType: 'Select Type',
      listOfTemplate: 'List of template',
      selectTemplate: 'Select Template',
      ElectricityVoltage: 'Electricity Voltage',
      ElectricityCurrent: 'Electricity Current',
      ElectricPowerFactor: 'Electric Power Factor',
      ElectricFrequency: 'Electric Frequency',
      EnergyReceived: 'Energy Received',
      ActivePower: 'Active Power',
      ActivePowerA: 'Active Power A',
      ActivePowerB: 'Active Power B',
      ActivePowerC: 'Active Power C',
      ReactivePower: 'Reactive Power',
      ApparentPower: 'Apparent Power',
      PeakDemand: 'Peak Demand',
      ElectricityCurrentA: 'Electricity Current A',
      ElectricityCurrentB: 'Electricity Current B',
      ElectricityCurrentC: 'Electricity Current C',
      ElectricityVoltageA: 'Electricity Voltage A',
      ElectricityVoltageB: 'Electricity Voltage B',
      ElectricityVoltageC: 'Electricity Voltage C',
      ElectricityConsumption: 'Electricity Consumption',
      loaderWelcomeMessage: 'Welcome to Onboarding Portal. Please wait.',
      latitudeAndLongitude: `Latitude & Longitude`,
      siteUpdateSuccessMessage: `Site Details Successfully Updated`,
      siteUpdateErrorMessage: `Error in updating site details`,
      provisioningFailedMessages :`Site provisioning failed. Please retry`,
      onboardAllSites : `Onboard All Sites`,
      geoCordinatesErrorMsg : 'Please verify the coordinates',
      tooltipCordinateMessage : 'coordinates must be between',
      emptyValueMessage: 'Empty value not allowed',

      browseFile:"Browse File",
      fileTypeErrorMsg:"File type is not allowed",

      orgImgTitle:"Upload Organization Logo",
      orgImgDropTxt:"Drag and Drop Logo",
      orgImgInfoTxt:"W {{width}}px X H {{height}}px and Only *.png file format",
      orgImgPreviewTxt:"Preview Logo",
      orgImgTooltipTxt:"Logo to have transparent background and should contrast black header background",
      orgImgSizeOfErrorMsg:"Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb",
     
      siteImgTitle:"Upload Site image",
      siteImgDropTxt:"Drag and Drop Building image (*.png or .jpg)",
      siteImgPreviewTxt:"Preview Site Details Page",
      siteTooltipTxt:"Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution",
      siteImgInfoTxt:"W {{width}}px X H {{height}}px and *.png & *.jpg file format",
      siteImgSizeOfErrorMsg:"Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb",
      orTxt:"Or",
      addLogo:"Add Logo",
      addImage:"Add Image",
      imageUploadSuccess:"Image Uploaded Successfully",
      alertnteId:"Alternate username: ",
      username:"Username: ",
      errorFetchingUser: "Error fetching user details",
      errorFetchingRoles: "Error fetching roles",

      gateway: "GATEWAY",
      associateAndSyncBtn: "ASSOCIATE & SYNC",
      cancelBtn: "CANCEL",
      guidValidationError: "GUID Validation Error",
      gatewayId: "GATEWAY ID",
      addNewGateway: "Add New Gateway",
      successMessage1: "Association of the site, completed",
      successMessage2: "Association of the site, completed. Model sync will be initiated",
      errorMessage: "Association failed, Model sync will not be initiated",
      importUsers:'Import Users',
      importUsersSubHeading:'Add and manage you would like to import by downloading the CSV template.',
      dropCsvHere:'Drag and drop file here or',
      browsrForFiles:'Browse for files',
      subHeadingBrowser:'Accepted only CSV  file and the file should not exceed 5mb.',
      subHeadingBrowserTwo:'(only one upload possible at a time)',
      userUploadSuccess:'Successfully data sent',
      userUploadProcessing: "The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.",
      fileNameDisplay:'File Name : ',
      fileName:'File Name',
      errorNotification:'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading:'Error',
      slnumber:"SL NO.",
      errorMessageHeading:'ERROR MESSAGE',
      endUserAgreement: 'Honeywell Forge Terms',
      privacyStatement: 'Privacy Statement',
      yourPrivacyChoices: 'Your Privacy Choices',
      cookieNotice: 'Cookie Notice',
      dataCentre: "Data Centre",
      isForgeText: "Buildings",
      gatewayIdleMessage:"You have been idle for few minutes please refresh the page to continue",
      refresh:"Refresh",
      landingLogin: "Click here",
      loginUserIntegratorRole: "BA e-commerce users",
      loginUserCustomerRole: "All other users",
      loginWelcomeNote: "Welcome, Please choose your role below to get started.",
      termsAndConditions: "Terms and conditions",
      accept: "Accept",
      legalPatentInformation: "Legal Patent Information",
      onboardingPortal: "Onboarding Portal",
      customers: "Customers",
      templates: "Templates",
      assetModelling: "Asset Modelling",
      selectCustomer: "Select Customer",
      integration: "Integration",
      integrationSubtitle: "Seamlessly Integrate for Real-Time Performance Insights",
      customer: 'Customer',
      accessibleCustomersError: "Error fetching accessible customers",
      workflows: "Workflows (Legacy)",
      apiCredentials: "API Credentials",
      integrationsTab: "Workflows",
      noSubscription: "No active subscription found. Please subscribe to access this feature.",
      loading:"Loading...",
      licenseManagement: "License Management",
      activityLogTitle: "Activity logs",
      activityLogSubtitle: "Track workflow events and status updates across selected customers",
      activityLogSidebarTitle: "Activity Logs",
      activityLogSidebarSubtitle: "Here are the activity data for all your customer organisations",
      activityLogListTitle: "List of activities",
      activityLogSearchPlaceholder: "Search by activity, site",
      activityLogLastUpdated: "Last Updated",
      activityLogCreatedOn: "Created On",
      activityLogActivity: "Activity",
      activityLogSite: "Site",
      activityLogStatus: "Status",
      activityLogCreatedBy: "Created By",
      activityLogUpdatedBy: "Updated By",
      activityLogNameUnavailable: "Name unavailable",
      activityLogUserNamesError: "Failed to load CreatedBy / UpdatedBy names",
      activityLogStatusSuccess: "Success",
      activityLogStatusFailed: "Failed",
      activityLogStatusInProgress: "In Progress",
      activityLogStatusQueued: "Queued",
      activityLogStatusPending: "Pending",
      activityLogPaginationInfo: "{startItem} - {endItem} of {totalItems} items",
      activityLogPageGoTo: "Go to page",
      activityLogRowPerPage: "Rows per page",
      activityLogRetry: "Retry",
      activityLogRetrying: "Retrying...",
      activityLogRetrySuccess: "Task retry initiated successfully.",
      activityLogRetryError: "Failed to retry task. Please try again.",
      activityLogRetryAllSuccess: "All tasks retried successfully.",
      activityLogRetryAllFailed: "All retry attempts failed. Please try again.",
      activityLogRetryPartialFailed: "Some tasks failed to retry. Please try again.",
      activityLogLoading: "Loading details...",
      activityLogFetchError: "Failed to load activity data. Please try again.",
      activityLogModalClose: "Close",
      activityLogModalTasks: "Tasks",
      activityLogModalCreatedOn: "Created on",
      activityLogModalLastUpdatedOn: "Last updated on",
      activityLogModalSupportNote: "Description about the failure event and the reason code.",
      activityLogModalSupportReach: "For assistance reach out to",
      activityLogModalSupportEmail: "connectedbuildingsupport@honeywell.com",
      activityLogFilterTitle: "Filter by",
      noCustomersAvailable: "No customers available",
      activityLogFilterStatus: "Status",
      activityLogFilterActivity: "Activity",
      activityLogFilterSite: "Site",
      activityLogFilterCreatedBy: "Created By",
      activityLogFilterApply: "Apply",
      activityLogFilterReset: "Reset",
      activityLogFilterNoOptions: "No options available",
      activityLogFilterError: "Failed to load filter options. Please try again.",
      search: "Search",
      more: "more",
      noResults: "No results found",
      activityLogCustomizeColumns: "Customize columns",
      activityLogColumnsReorder: "Reorder",
      activityLogColumnsAddRemove: "Add/Remove",
      activityLogColumnsReorderDescription: "Reposition to change order of columns in the table",
      activityLogColumnsAddRemoveDescription: "Check columns to display them in the table",
      activityLogDetails: "Details",
      activityLogFiltersChanged: "No data found for the selected filters. Please adjust or reset your filters to see results.",
      activityLogResetFilters: "Reset Filters",
      activityLogSiteState: 'State',
      activityLogSiteCity: 'City',
      workflowTaskCBCustomerCreation: "CB Customer Creation",
      workflowTaskOnboardingStatusUpdatePartnerPortal: "Onboarding status update in partner portal",
      workflowTaskUpdateCBCustomerIdPartnerPortal: "Update CB Customer Id in partner portal",
      workflowTaskEOMCustomerCreation: "EOM Customer Creation",
      workflowTaskOnboardCustomerForAI: "Onboard customer for AI",
      workflowTaskDeleteCustomerInCBPortal: "Delete Customer in CB Portal",
      workflowTaskUpdateCustomerInCBPortal: "Update Customer in CB Portal",
      workflowTaskUpdateCustomerInEOM: "Update Customer in EOM",
      workflowTaskUpdateCustomerInAssetModelling: "Update Customer in asset modelling",
      workflowTaskTrackScanStatusFileAttachment: "Track scan status of file attachment",
      workflowTaskCBSiteCreation: "CB Site Creation",
      workflowTaskUpdateCBSiteIdPartnerPortal: "Update CB Site Id in partner portal",
      workflowTaskEOMSiteCreation: "EOM Site Creation",
      workflowTaskUpdateEOMSiteIdPartnerPortal: "Update EOM Site Id in partner portal",
      workflowTaskSyncExistingUsersCBPortal: "Sync existing users to CB Portal",
      workflowTaskUpdateUserSyncStatusPartnerPortal: "Update user sync status in partner portal",
      workflowTaskCalculateEnergySavingsPotential: "Calculate Energy Savings Potential",
      workflowTaskDeleteSiteInCBPortal: "Delete Site in CB Portal",
      workflowTaskDeleteSiteInEOM: "Delete Site in EOM",
      workflowTaskUpdateSiteInCBPortal: "Update Site in CB Portal",
      workflowTaskUpdateSiteInEOM: "Update Site in EOM",
      workflowTaskUpdateSiteInAssetModelling: "Update Site in asset modelling",
      workflowTaskUpdateSiteInFindAPI: "Update Site in Find API",
      workflowTaskSyncSubscriptionAssociationCBPortal: "Sync subscription association to CB Portal",
      workflowTaskEnableBrickOntology: "Enable Brick ontology",
      workflowTaskOnboardCustomerForgeAPI: "Onboard Customer to ForgeAPI",
      workflowTaskPublishForgeAPIOnboardingStatus: "Publish ForgeAPI onboarding status to Credential Management",
      workflowTaskAddUserInCBPortal: "Add user in CB portal",
      workflowTaskUpdateUserProvisioningStatus: "Update user provisioning status",
      workflowTaskDeleteUserInCBPortal: "Delete user in CB portal",
      workflowTaskUpdateUserDeletionStatus: "Update user deletion status",
      workflowCustomerCreation: "Customer Creation",
      workflowCustomerDelete: "Customer Delete",
      workflowCustomerUpdate: "Customer Update",
      workflowFileAttachmentsScan: "File attachments scan status",
      workflowSiteCreation: "Site Creation",
      workflowSiteDelete: "Site Delete",
      workflowSiteUpdate: "Site Update",
      workflowSubscriptionAssociation: "Subscription Association",
      workflowAddUser: "Add User",
      workflowDeleteUser: "Delete User",
      workflowNamePlate:'Name Plate',
      workflowForgeAPIOnboarding: "Forge API Onboarding",
      workflowAddUserMultiple: "Workflow to add user Multiple",
      workflowDeleteUserMultiple: "Workflow to Delete user Multiple",
      workflowModelFileUpload: "Model File Upload",
      workflowGatewayAssociation: "Gateway Association",
      workflowTaskForgeAPIOnboardingStatus: "Forgeapi Onboarding status",
      workflowTaskAddUser: "Workflow to add user",
      workflowTaskProcessModelFile: "Process model file",
      workflowTaskNotifyAssetModelling: "Notify asset modelling",
      workflowTaskAssociateGateway: "Associate gateway to site",
      workflowTaskFetchModelToAssetModelling: "Fetch model to asset modelling",
      workflowTaskNameProcessNamePlate:'Process Nameplate File.',
      workflowTaskUpdateModelInFindAPI:'Update Model in Find API',
      activityLogCorrelationId: "Correlation id",
      activityLogTaskId: "Task id",
      activityLogToastSuccess: "Success",
      activityLogToastError: "Error",
      activityLogIteration: "Iteration",
      activityLogFieldFirstName: "First Name",
      activityLogFieldLastName: "Last Name",
      activityLogFieldSubscriptionName: "Subscription Name",
      activityLogFieldName: "Name",
      activityLogFieldCurrency: "Currency",
      activityLogFieldZip: "Zip",
      activityLogFieldArea: "Area",
      activityLogFieldCity: "City",
      activityLogFieldState: "State",
      activityLogFieldCountry: "Country",
      activityLogFieldAreaUnit: "Area Unit",
      activityLogFieldLanguage: "Language",
      activityLogFieldLatitude: "Latitude",
      activityLogFieldSiteType: "Site Type",
      activityLogFieldTimezone: "Timezone",
      activityLogFieldLongitude: "Longitude",
      activityLogFieldCountryCode: "Country Code",
      activityLogFieldSiteId: "Site Id",
      activityLogFieldAddressLine1: "Address Line 1",
      activityLogFieldAddressLine2: "Address Line 2",
      activityLogFieldContactEmail: "Contact Email",
      activityLogSiTitle:'Activity Log'
    }
  }
};
